import { render, staticRenderFns } from "./UserPermissionsModal.1.vue?vue&type=template&id=1a487314&scoped=true&"
import script from "./UserPermissionsModal.1.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsModal.1.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserPermissionsModal.1.vue?vue&type=style&index=1&id=1a487314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a487314",
  null
  
)

export default component.exports